import {logSendInBlueClassEvent, AbstractPlayClassController} from "./AbstractPlayClassController";
import {EndStepAction, PreviousStepAction} from "../../models/types/ClassTypes";
import {PlayClass} from "../../models/class-structure/generic/PlayClass";
import {ClassStep} from "../../models/class-structure/generic/ClassStep";

import {MasteriesService} from "../../../masteries/MasteriesService";
import {analyticsController} from "../../../user/analytics/AnalyticsController";
import {playClassService} from "../../PlayClassService";

export class SingleClassController extends AbstractPlayClassController {

  /* Class Content */
  public get orderedClassControllers(): AbstractPlayClassController[] {
    return [this]
  }

  /* Status */
  public currentStepId: number;

  constructor(playClass: PlayClass, hasDemo: boolean = false) {
    super(playClass, hasDemo)

    if(playClass.progress.isFinished) {
      this.currentStepId = 0
    }
    else {
      this.currentStepId = playClass.progress.maxStepId + 1;
    }
  }

  /* Play Class Interface */

  get activeClass(): PlayClass {
    return this.playClass;
  }

  get activeStep(): ClassStep {
    if (this.shouldDisplayDemo) {
      return this.playClass.getDemoStep(this.isClassStarted())
    }
    return this.playClass.getStep(this.currentStepId);
  }

  get previousStep(): ClassStep | null {
    if (this.currentStepId === 0) {
      if (this.hasDemo) {
        return this.playClass.getDemoStep(this.isClassStarted())
      }
      return null
    }
    return this.playClass.getStep(this.currentStepId - 1);
  }

  /* Step Manipulation */
  public loadNextStep(): EndStepAction {
    this.logStepAnalytics('next step class')
    logSendInBlueClassEvent('next_step_class');

    const endStepAction = this.getEndStepAction();
    this.validateCurrentStep();
    switch (endStepAction) {
      case "END_CLASS":
        this.isFinished = true;
        break;
      case "NEXT_STEP":
        if (this.shouldDisplayDemo) {
          this.isDemoCompleted = true;
        }
        else {
          this.currentStepId++;
        }
        break;
      case "NEXT_CLASS":
        console.error('Should not get "NEXT_CLASS" here');
        break;
    }
    return endStepAction;
  }
  public getEndStepAction(): EndStepAction {
    if (this.shouldDisplayDemo) {
      return 'NEXT_STEP';
    }
    else if (this.currentStepId >= this.playClass.steps.length - 1) { // Is on last step
      return 'END_CLASS';
    }
    else {
      return 'NEXT_STEP';
    }
  }

  public loadPreviousStep(): PreviousStepAction {
    this.logStepAnalytics('previous step class')

    if (this.previousStep) {
      if (this.previousStep.playerConfig.playerMode !== 'preview') {
        this.currentStepId--;
      }
      return "PREVIOUS_STEP";
    }
    else {
      return "CLASS_START";
    }
  }

  public setClassAndStep(classId: number, stepId: number|'demo') {
    this.isDemoCompleted = true; // Because demo is out of class & steps workflow
    if (stepId === 'demo') {
      this.isDemoCompleted = false;
    }
    else {
      this.currentStepId = stepId;
    }
  }

  /* Remote Status */
  public validateCurrentStep() {
    if (!this.shouldDisplayDemo) {
      playClassService.validateStep(this.activeClass.id, this.activeStep.id);

      if (this.activeStep.requireValidation) {
        // TODO (v2): could move masteries save to back end to match challenge implementation
        MasteriesService.validateMasteries(this.activeClass.playableContent).then();
      }
    }
  }

  /* Helpers */
  private logStepAnalytics(title: string) {
    analyticsController.logBasicAnalyticsEvent(title, 'Class Events', {
      action: this.getEndStepAction(),
      class_id: this.activeClass.id,
      class_type: this.activeClass.type,
      step_id: this.currentStepId,
      name: this.activeClass.playableContent.name}
    )
  }
}
